import PropTypes from "prop-types"
import "./style.scss"

function NoBetas({ modelId }) {
  return <div className="components_no-betas">
    <h2>Betas not available with the current model ({modelId})</h2>
    <p>Please consider switching models</p>
  </div>
}

NoBetas.propTypes = {
  modelId: PropTypes.string.isRequired,
}

export default NoBetas
